import axios from "@/plugins/axios";

class EventosService {
  async getAll() {
    const res = await axios.get("/eventos");
    return res.data;
  }
  
  async create(data) {
    const res = await axios.post("/eventos", data);
    return res.data;
  }
  
  async update(id, data) {
    const res = await axios.patch(`/eventos/${id}`, data);
    return res.data;
  }
  
  async delete(id) {
    const res = await axios.delete(`/eventos/${id}`);
    return res.data;
  }
}
export default new EventosService();